import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { clearSkip, forwardNavigation } from 'actions/general'
import withRouter from '../../hocs/with-router'

function mapStateToProps(state) {
  return {
    available: state.general.get('skip'),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    clearSkip: payload => dispatch(clearSkip(payload)),
    forwardNavigation: payload => dispatch(forwardNavigation(payload)),
  }
}

class Skip extends PureComponent {
  onClick = () => {
    this.props.clearSkip()
    this.props.forwardNavigation()
  }

  render() {
    return this.props.available ? (
      <div className='skip'>
        <span
          id='ext--skip-button'
          data-test-key='skip-button'
          className='skip--text'
          onClick={this.onClick}
        >
          skip
        </span>
      </div>
    ) : null
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Skip))
